<template>
  <section class="s-results-table">
    <div class="s-results-table__conts">
      <div class="s-results-table__col">
        <Loader v-if="isLoading" display="absolute"></Loader>
        <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs" />

        <div class="s-results-table__head">
          <div class="s-results-table__filters">
            <div class="s-results-table__filters__desk">
              <Dropdown
                :options="filters.companyName"
                :label="dictionary.companyNameLabel"
                :is-mobile="false"
                @select-dropdown="getCompanyNameValue"
                @reset="resetName"></Dropdown>

              <Dropdown
                :options="filters.years"
                :label="dictionary.yearLabel"
                :is-mobile="false"
                @select-dropdown="getYearValue"
                @reset="resetYear"></Dropdown>
            </div>

            <SlideRightFilters
              :label="dictionary.filters"
              :years-options="filters.years"
              :company-name-options="filters.companyName"
              :year-label="dictionary.yearLabel"
              :company-name-label="dictionary.companyNameLabel"
              :button-label="dictionary.filtersButtonLabel"
              @change-filters="getFiltersValue"
              @reset-year="resetYear"
              reset-name="resetName"></SlideRightFilters>
          </div>

          <div class="s-results-table__title" v-if="resultsCount > 0">
            <div class="s-results-table__resultsTitle">{{ resultsTitle }}</div>
            <div class="s-results-table__pagination">
              <!-- <Pagination
                :key="'search-pagination-' + paginationUpdateKey"
                :results-count="resultsCount"
                :page-size="pageSize"
                @page-changed="pageChanged"></Pagination> -->
            </div>
          </div>
        </div>

        <div class="b-results-table" v-if="resultsCount > 0">
          <div class="b-results-table__head">
            <div
              class="b-results-table__td"
              v-for="(header, i) in headers"
              :key="i">
              {{ header }}
            </div>
          </div>
          <div class="b-results-table__body">
            <div
              class="b-results-table__row"
              v-for="item in results"
              :key="item.id">
              <div class="b-results-table__td b-results-table__td--name">
                {{ item.companyName }}
              </div>
              <div class="b-results-table__td">{{ item.announcement }}</div>
              <div class="b-results-table__td b-results-table__td--date">
                {{ item.date }}
              </div>
              <div
                class="b-results-table__td b-results-table__td--file"
                v-if="item.file">
                <a :href="item.file" download>
                  <div class="e-download">
                    <Vue3Lottie
                      :ref="`lottiePlayer-${item.id}`"
                      animation-link="./../../../imgs/lotties/downloadFile.json"
                      :auto-play="false"
                      :height="24"
                      :width="24"
                      @mouseover="lottiePlay(item)"
                      @mouseleave="lottieStop(item)" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="b-products-table--mob">
          <div
            v-for="item in results"
            :key="item.id"
            class="b-products-table__row">
            <span>{{ item.announcement }}</span>
            <div class="b-products-table__td">
              <span>{{ Object.values(headers)[0] }}</span>
              <span>{{ item.companyName }}</span>
            </div>
            <div class="b-products-table__td">
              <span>{{ Object.values(headers)[2] }}</span>
              <span>{{ item.date }}</span>
            </div>
            <div class="b-products-table__td">
              <span>{{ Object.values(headers)[3] }}</span>
              <a :href="item.file" download>
                {{ dictionary.download }}
                <div class="e-download">
                  <Vue3Lottie
                    :ref="`lottiePlayer-${item.id}`"
                    animation-link="./../../../imgs/lotties/downloadFile.json"
                    :auto-play="false"
                    :height="24"
                    :width="24" />
                </div>
              </a>
            </div>
          </div>
        </div>

        <div class="s-results-table__pagination">
          <Pagination
            :key="'res-pagination-' + paginationUpdateKey"
            :results-count="resultsCount"
            :page-size="pageSize"
            @page-changed="pageChanged"></Pagination>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import Alert from '../components/common/Alert.vue'
import Loader from '../components/common/Loader.vue'
import Pagination from '../components/common/Pagination.vue'
import { Vue3Lottie } from 'vue3-lottie'
import Dropdown from '../components/common/Dropdown.vue'
import SlideRightFilters from '../components/common/SlideRightFilters.vue'
import * as lib from '../../lib/lib'

export default {
  components: {
    Alert,
    Loader,
    Pagination,
    Vue3Lottie,
    Dropdown,
    SlideRightFilters,
  },

  data() {
    return {
      // default

      isLoading: false,
      errorMsgs: [],
      headers: [],
      filters: [],
      results: [],
      resultsCount: 0,
      pageSize: 10,
      page: 1,
      paginationUpdateKey: 0,
      year: '',
      companyName: '',
    }
  },
  computed: {
    resultsTitle() {
      return this.dictionary.resultsTitle
        .replace('{y}', this.resultsCount)
        .replace('{x}', this.page * this.pageSize)
    },
  },
  mounted() {
    const { headers, filters } = lib.getData('resultsTableData')

    this.headers = headers
    this.filters = filters
    this.paginationUpdateKey++
    this.fetchData(this.page)
  },

  methods: {
    getCompanyNameValue(name) {
      this.companyName = name
      this.fetchData(1)
    },

    getYearValue(year) {
      this.year = year

      this.fetchData(1)
    },

    getFiltersValue(name, year) {

    
      this.companyName = name
      this.year = year
      this.fetchData(1)
    },

    resetYear(){
      this.year = ''
      this.fetchData(1)
    },

    resetName(){
      this.companyName = ''
        this.fetchData(1)
    },

    fetchData(page) {
      this.isLoading = true

      const payload = {
        page: page,
        pageSize: this.pageSize,
        companyId: this.companyName,
        year: this.year,
      }

      axios
        .post(this.configuration.endpointSearchResults, payload)
        .then((response) => {
          const { hasError, errorMessages, data } = response.data

          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          this.$nextTick(() => {
            this.handleSuccess(data)
          })
        })
        .catch((errors) => {
          console.error(errors)
        })
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },

    handleSuccess(data) {
      this.errorMsgs = []
      this.isLoading = false
      this.resultsCount = data.resultsCount
      this.results = data.results
      lib.scrollToElem(jQuery(this.$el))
    },

    pageChanged(newPage) {
      this.page = newPage
      this.fetchData(this.page)
    },

    lottiePlay(item) {
      const lottie = this.$refs[`lottiePlayer-${item.id}`][0]
      lottie.play()
    },
    lottieStop(item) {
      const lottie = this.$refs[`lottiePlayer-${item.id}`][0]
      lottie.goToAndStop(0)
    },
  },

  // watch:{
  //   page(newVal){
  //     if(newVal)
  //      this.paginationUpdateKey++
  //   }
  // }
}
</script>
